module.exports = __webpack_public_path__ + "img/optimizing-dosing.74f243b6.svg";